var map = {
	"./3dots1.png": 66350,
	"./3dots2.png": 36709,
	"./card-frame.png": 59492,
	"./doc.png": 14558,
	"./heart.png": 52656,
	"./jpg.png": 24373,
	"./pdf.png": 42090,
	"./png.png": 90481,
	"./txt.png": 99576,
	"./vector.png": 18603,
	"./xl4.png": 42776
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50393;